<template>
  <div>
    <div
      v-if="!styleObject"
      class="loader
        d-flex
        align-items-center
        justify-content-center
        w-100
        h-100"
      :class="['position-' + position]"
      :style="[styleColor]"
    >
        <span
          class="spinner
            position-absolute
            center"
        ></span>
    </div>
    <div v-else
         :style="styleObject">
      <div
        class="loader
        d-flex
        align-items-center
        justify-content-center
        w-100
        h-100
        position-absolute"
      >
        <span
          class="spinner
            position-absolute
            center"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      styleObject: {
        type: Object
      },
      position: {
        type: String,
        default: 'absolute'
      },
      color: {
        type: String,
        default: 'white'
      }
    },
    computed: {
      styleColor() {
        if (this.color === 'grey') {
          return {
            backgroundColor: 'rgb(228, 229, 230, .7)'
          };
        }

        return {
          backgroundColor: 'rgba(255, 255, 255, .7)'
        };
      }
    }
  }
</script>

<style lang="scss">
.loader {
  background-color: rgba(255, 255, 255, .7);
  border-radius: 10px;
  z-index: 5;
  top: 0;
  left: 0;
  .spinner {
    width: 64px;
    height: 64px;
    &:after {
      content: " ";
      display: block;
      width: 46px;
      height: 46px;
      margin: 1px;
      border-radius: 50%;
      border: 5px solid transparent;
      border-color: #684388 transparent #684388 transparent;
      opacity: 0.65;
      animation: lds-dual-ring 1.2s linear infinite;
    }
  }
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>